import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { UrlModule } from '../../../../core/routing';
import {
  CheckboxModule,
  DrawerModule,
  GenericLinkModule,
  IconThemeReverseModule,
  PipesModule,
  PrincipalConfigurationDirectiveModule,
} from '../../../../shared';
import { BadgeModule } from '../../../../shared/components/badge/badge.module';
import { CatalogFilterFacetModule } from '../catalog-filter-facet/catalog-filter-facet.module';
import { CatalogSortModule } from '../catalog-sort/catalog-sort.module';
import { CatalogFilterComponent } from './catalog-filter.component';

@NgModule({
  declarations: [CatalogFilterComponent],
  exports: [CatalogFilterComponent],
  imports: [
    CommonModule,
    I18nModule,
    DrawerModule,
    NzIconModule,
    RouterModule,
    CatalogFilterFacetModule,
    GenericLinkModule,
    CheckboxModule,
    PrincipalConfigurationDirectiveModule,
    CatalogSortModule,
    BadgeModule,
    UrlModule,
    PipesModule,
    IconThemeReverseModule,
  ],
})
export class CatalogFilterModule {}
